import {getTranslate} from '@api/Languge';
import {LANGUAGE} from '@constants/variables';
import axios from 'axios';
import _ from "lodash-es";

export const setLocalLang = (lang: string) => {
  localStorage.setItem("b2clang", lang);
}

export const getLocalLang = () => {
  return localStorage.getItem('b2clang');
}

export const formatParams = (obj: any) => {
  return Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
}

export const request = async (url: string, options: any) => {
  try {
    const response = await fetch(url, options);
    const responseJSON = await response.json();
    return responseJSON;
  } catch (e) {
    window.open('/page-error', '_self');
    return {error: 'SERVER_ERROR'}
  }
}

export const clean = (obj: any) => {
  for (let propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
}

export const translate = (bundle: any, code: any, defaultText: string = code, variables: any = {}) => {
  try {
    const {search} = window.location;
    if (/debug/.test(search)) return code;
    if (bundle && code) {
      // console.log('translate bundle', bundle);
      let value: any;

      if (_.isString(code)) {
        if (_.has(bundle, code?.toUpperCase())) {
          value = bundle[code?.toUpperCase()];
        } else {
          value = code;
        }
      }
      if (_.isArray(code)) {
        value = _.join(_.map(code, (v, k) => {
          return "<span class='error'>" + (bundle[v?.toUpperCase()] || v) + "&#46;</span>";
        }), "");
      }

      if (_.isUndefined(value)) {
        return defaultText;
      } else {
        if (_.isEmpty(variables)) {
          return value;
        } else {
          let output = value;
          _.forIn(variables, function (varValue, varKey) {
            output = output.replace(new RegExp(`\\{${varKey}\\}`, 'g'), varValue);
          });
          return output;
        }
      }
    }
    return code;
  } catch (e) {
    console.error(e, code, typeof code, bundle);
    return code;
  }
};

export const translateMessage = (bundle: any, mes: any) => {
  if (typeof mes === "object" && mes.length !== undefined) { // mes is array
    const arrMes = mes.map((m: string) => translate(bundle, m.toUpperCase()));
    return arrMes.join(', ');
  } else if (typeof mes === "string") {
    return translate(bundle, mes.toUpperCase());
  } else {
    return mes;
  }
}

export const setLang = async (dispatch: any, code: string) => {
  const {data} = await getTranslate(code);
  clean(data[code]);
  dispatch({
    type: 'ADD_CURRENT_LANG', currentLang: {
      ...data[LANGUAGE.EN],
      ...data[code]
    },
    lang: code
  });
  setLocalLang(code);
}

export const getLengthDescription = (str: string) => {
  const noHTML = str.replace(/<\/?[^>]+(>|$)/g, "");
  const arrWord = noHTML.split(" ");

  return arrWord.length;
}

export const formatShortDescription = (str: string, number: number = 100) => {
  const noHTML = str.replace(/<\/?[^>]+(>|$)/g, "");
  const arrWord = noHTML.split(" ");
  arrWord.length = number;
  return arrWord.join(" ");
}

interface IImg {
  image_position: number,
  image_url: string
}

export const formatImgUrl = (arrImg: IImg[], position: number) => {
  const imgObj = arrImg.find((img: IImg) => img.image_position === position)
  if (imgObj) {
    return imgObj.image_url
  }

  return '';
}

export function getParams(urlParams: string = '') {
  let url;
  let location;
  let queryString;
  if (!urlParams) {
    if (window && window.location) {
      location = window.location;
      url = location.pathname + location.search;
    }
  } else {
    url = urlParams;
  }
  // get query string from url (optional) or window
  if (location && location.search) {
    queryString = url ? url.split('?')[1] : location.search.slice(1);
  }

  // we'll store the parameters here
  const obj: any = {};

  // if query string exists
  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    const arr = queryString.split('&');

    arr.forEach(item => {
      // separate the keys and the values
      const a = item.split('=');

      // in case params look like: list[]=thing1&list[]=thing2
      let paramNum;
      const paramName = a[0].replace(/\[\d*\]/, v => {
        paramNum = v.slice(1, -1);
        return '';
      });

      // set parameter value (use 'true' if empty)
      const paramValue = typeof a[1] === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      // paramName = paramName.toLowerCase();
      // paramValue = paramValue.toLowerCase();

      // if parameter name already exists
      if (obj[paramName]) {
        // convert value to array (if still string)
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]];
        }
        // if no array index number specified...
        if (typeof paramNum === 'undefined') {
          // put the value on the end of the array
          obj[paramName].push(paramValue);
        } else {
          // if array index number specified...
          // put the value at that index number
          obj[paramName][paramNum] = paramValue;
        }
      } else {
        // if param name doesn't exist yet, set it
        obj[paramName] = paramValue;
      }
    });
  }

  return obj;
}

export const parseJSON = (response: any) => {
  return new Promise(resolve => {
    resolve({
      status: response.status,
      statusText: response.statusText,
      json: response.data,
      headers: response.headers
    });
  });
};

export const axiosRequest: any = (url: string, options: any) =>
  new Promise((resolve, reject) => {
    axios({
      url,
      ...(options.body ? {data: options.body} : {}),
      ...options
    })
      .then(parseJSON)
      .then((response: any) => {
        const data = response.json;

        if (response.status) {
          data.status = response.status;
        }

        resolve(data);
      })
      .catch(error => {
        const {response} = error;
        if (response) {
          if (response.status === 403) {
            window.open('/forbidden', '_self');
          } else if (response.status === 500) {
            window.open('/page-error', '_self');
          } else if (response.status === 503) {
            window.open('/maintenance', '_self');
          }

          if (response.data) {
            resolve(response.data);
          }
        } else {
          /**
           * @todo: implement ErrorBoundary
           */
        }
      });
  });

export const scrollToRef = (ref: any) => window.scrollTo(0, ref.current.offsetTop);

export const numberToWord = (num) => {
  if (num === 0) return 'zero';

  const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];

  let word = '';
  if (num >= 1000) {
    word += numberToWord(Math.floor(num / 1000)) + ' thousand ';
    num %= 1000;
  }
  if (num >= 100) {
    word += ones[Math.floor(num / 100)] + ' hundred ';
    num %= 100;
  }
  if (num >= 10 && num < 20) {
    word += teens[num - 10] + ' ';
    return word.trim();
  }
  if (num >= 20) {
    word += tens[Math.floor(num / 10)] + ' ';
    num %= 10;
  }
  if (num > 0) {
    word += ones[num] + ' ';
  }
  return word.trim();
}
export const isEmptyValues = (value) => {
  const type = typeof value;
  if ((value !== null && type === 'object') || type === 'function') {
    const properties: any = Object.keys(value);
    if (((properties.length === 0 || properties.size === 0) && !(value instanceof File)) || (value instanceof File && value.name && value.size)) {
      return true;
    }
  }

  if (_.isArray(value) && _.some(value, (b) => _.isEmpty(b))) {
    return true;
  }

  if (type === "boolean") {
    return false;
  }

  return !value;
}

export const translateV1Alt = (bundle: any, code: any, defaultText: string = code, variables: any = {}) => {
  try {
    const {search} = window.location;
    if (/debug/.test(search)) return code;
    if (bundle && code) {
      // console.log('translate bundle', bundle);
      let value: any;

      if (_.isString(code)) {
        if (_.has(bundle, code?.toUpperCase())) {
          value = bundle[code?.toUpperCase()];
        } else {
          value = code;
        }
      }
      if (_.isArray(code)) {
        value = _.join(_.map(code, (v, k) => {
          return "<span class='error'>" + (bundle[v?.toUpperCase()] || v) + "&#46;</span>";
        }), "");
      }

      if (_.isUndefined(value)) {
        return defaultText;
      } else {
        if (_.isEmpty(variables)) {
          return value;
        } else {
          let output = value;
          _.forIn(variables, function (varValue, varKey) {
            output = output.replace(new RegExp(`\\{${varKey}\\}`, 'g'), varValue);
          });
          return output;
        }
      }
    }
    return code;
  } catch (e) {
    console.error(e, code, typeof code, bundle);
    return code;
  }
};

export const getQueryParams = (url) => {
  let params = {};
  let queryString = url.split('?')[1]; // Get the query string part

  if (queryString) {
    queryString = queryString.split('#')[0]; // Remove hash fragment if exists
    let pairs = queryString.split('&');

    pairs.forEach(pair => {
      let [key, value] = pair.split('=');
      params[decodeURIComponent(key)] = decodeURIComponent(value || '');
    });
  }

  return params;
}


/**
 * Creates a search query string from the given query object.
 *
 * @param {Object} queryObject - The query object from which to create the search query.
 * @returns {string} - The created search query string.
 */
export const createSearchQuery = (queryObject = {}) => {
  try {
    const qs = {}
    let query = new URLSearchParams(qs);
    _.forIn(queryObject, (value, key) => {
      if (query.has(key)) {
        query.set(key, _.escape(value));
      } else {
        query.append(_.escape(key), _.escape(value));
      }
    })
    return query.toString();
  } catch (e) {
    console.error(e)
    const qs = getParams();
    let query = new URLSearchParams(qs);
    return query.toString();
  }
}

/**
 * Get current query params and builds a search query string by appending from the provided query object
 *
 * @param {Object} queryObject - The query object containing key-value pairs.
 * @returns {string} - The constructed search query string.
 */
export const buildSearchQuery = (queryObject = {}) => {
  try {
    const qs = getParams();
    let query = new URLSearchParams(qs);
    _.forIn(queryObject, (value, key) => {
      if (query.has(key)) {
        query.set(key, _.escape(value));
      } else {
        query.append(_.escape(key), _.escape(value));
      }
    })
    return query.toString();
  } catch (e) {
    console.error(e)
    const qs = getParams();
    let query = new URLSearchParams(qs);
    return query.toString();
  }
}